import { getUserRoles } from "@/shared/api/permissions";
import { Module } from "vuex";
import { RootState } from "../index";

export interface IState {
  roles: [];
}

const authModule: Module<IState, RootState> = {
  namespaced: true,
  state: {
    roles: [],
  },
  mutations: {
    SET_ROLES(state, response) {
      state.roles = response;
    },
  },
  actions: {
    async setUser({ commit }, payload) {
      try {
        const { data } = await getUserRoles(payload.sub);
        commit("SET_ROLES", data || []);
      } catch (e) {
        console.error(e);
      }
    },
  },
};

export default authModule;
